/**
 * Townsend personalization
 * ------------------------
 * Makes the "Family Name" personalization input (rendered in a separate
 * block via snippets/townsend-personalization.liquid) submit with the main
 * product form, and blocks add-to-cart while a required field is empty.
 *
 * The theme's <product-form> element listens for `submit` in the BUBBLE phase
 * and immediately preventDefaults into an AJAX request, so this guard runs in
 * the CAPTURE phase and calls stopImmediatePropagation() to stop the add when
 * validation fails (works in both the AJAX and no-JS "afterAtc" modes).
 */
(function () {
  'use strict';

  var FORM_SELECTOR = '.js-product-form-main';
  var WRAPPER_SELECTOR = '[data-townsend-personalization]';
  var INPUT_SELECTOR = '[data-townsend-personalization-input]';
  var ERROR_SELECTOR = '[data-townsend-personalization-error]';

  function fieldError(input) {
    var wrapper = input.closest(WRAPPER_SELECTOR);
    return wrapper ? wrapper.querySelector(ERROR_SELECTOR) : null;
  }

  function clearError(input) {
    input.removeAttribute('aria-invalid');
    var error = fieldError(input);
    if (error) error.hidden = true;
  }

  function showError(input) {
    input.setAttribute('aria-invalid', 'true');
    var error = fieldError(input);
    if (error) error.hidden = false;
  }

  function init(root) {
    root = root || document;

    var inputs = Array.prototype.slice.call(root.querySelectorAll(INPUT_SELECTOR));
    if (!inputs.length) return;

    var form = document.querySelector(FORM_SELECTOR);
    if (!form) return;

    // Associate each input with the product form so FormData(form) picks it up,
    // even though the input lives outside the <form> element. The snippet may
    // already set this in Liquid; setting it here is the authoritative fallback.
    if (form.id) {
      inputs.forEach(function (input) {
        input.setAttribute('form', form.id);
      });
    }

    // Clear the error as soon as the customer starts typing.
    inputs.forEach(function (input) {
      if (input.dataset.townsendBound) return;
      input.dataset.townsendBound = 'true';
      input.addEventListener('input', function () {
        if (input.value.trim() !== '') clearError(input);
      });
    });

    // One capture-phase guard per form.
    if (form.dataset.townsendGuard) return;
    form.dataset.townsendGuard = 'true';

    form.addEventListener('submit', function (evt) {
      var firstInvalid = null;

      inputs.forEach(function (input) {
        var required = input.dataset.required === 'true';
        var empty = input.value.trim() === '';

        if (required && empty) {
          showError(input);
          if (!firstInvalid) firstInvalid = input;
        } else {
          clearError(input);
        }
      });

      if (firstInvalid) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        firstInvalid.focus();
      }
    }, true); // capture phase — runs before <product-form>'s handler
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Re-bind when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (evt) {
    init(evt.target);
  });
})();
